export const firstnameValidator = firstname => {
    if (!firstname) {
      return "First Name is required";
    } else if ((firstname.trim()).length < 3) {
      return "First Name must have a minimum 3 characters";
    } else if(!new RegExp(/^[A-Za-z ]*$/).test(firstname)){

      return "First Name must be valid";
    }
    return "";
  };

  export const lastnameValidator = lastname => {
    if (!lastname) {
      return "Last Name is required";
    } else if ((lastname.trim()).length < 3) {
      return "Last Name must have a minimum 3 characters";
    } else if(!new RegExp(/^[A-Za-z ]*$/).test(lastname)){
      return "Last Name must be valid";
    }
    return "";
  };
  export const companyValidator = company => {
    if (!company) {
      return "Company Name is required";
    } else if ((company.trim()).length < 2) {
      return "Company Name must have a minimum 2 characters";
    }else if(!new RegExp(/^[a-zA-Z0-9()&,\-. ]+$/).test(company)){
      return "Company Name is invalid";
    }
    return "";
  };

  export const emailValidator = (email, form) => {
    if (!email) {
      return "Email is required";
    } else if (!new RegExp(/\S+@\S+\.\S+/).test(email)) {
      return "Incorrect email format";
    } else if(form.confirmemail && (email.toLowerCase() !== form.confirmemail.toLowerCase())) {
      return "Email not matched with Confirm Email.";
    } else if(form.confirmemail && (email.toLowerCase() === form.confirmemail.toLowerCase()) && !(new RegExp(/\S+@\S+\.\S+/).test(email))) {
      return "Incorrect email format";
    } else if(form.confirmemail && (email.toLowerCase() === form.confirmemail.toLowerCase()) && new RegExp(/\S+@\S+\.\S+/).test(email)) {
      return "";
    }
    return "";
  };
  
  export const confirmemailValidator = (confirmemail,form) => {
        if (!confirmemail) {
            return "Confirm Email is required";
        } else if (!new RegExp(/\S+@\S+\.\S+/).test(confirmemail)) {
          return "Incorrect email format";
        } else if (confirmemail.toLowerCase() !== form.email.toLowerCase()) {
          return "Confirm Email do not match";
        }
        return "";
  };

  export const phoneValidator = phone => {
    if (!phone) {
      return "Phone is required";
    } else if(phone && !new RegExp(/^(?!\(000\) 000-0000$)\(\d{3}\) \d{3}-\d{4}$/).test(phone)){
      return "Phone is invalid"
    }
    return "";
  };

  export const zipcodeValidator = locationZip => {
    if(!locationZip){
      return "Zip is required";
    }else if (!new RegExp(/^(?!0{2,})\d{5}(?:-\d{4})?$/).test(locationZip)) {
      return "Incorrect zip format";
    }
    return "";
  };

  export const cityValidator = locationCity => {
    if(!locationCity){
      return "City is required";
    } else if (locationCity.length < 3) {
      return "City must have a minimum 3 characters";
    }else if(!new RegExp(/^[a-zA-Z][a-zA-Z ]*$/).test(locationCity)){
      return "City is invalid"
    }
    return "";
  };

  export const stateValidator = locationST => {
    // if(!locationST){
    //   return "State is required";
    // }
    return "";
  };

  export const commentValidator = comment => {
    if(comment && comment.length > 200){
      return "Comment must not be greater than 200 characters";
    }
    return "";
  };